import { FC } from 'react';
import { Flex, FlexProps, ButtonProps, Text, TextProps } from '@chakra-ui/react';
import { CbArrow } from '../Buttons/CbArrow';
export interface CbSimplePaginationProps {
  buttonSize?: number;
  buttonStyles?: ButtonProps | {};
  containerStyles?: FlexProps | {};
  count: number;
  currentIndex: number;
  textStyles?: TextProps;
  onChange?: (page: number) => void;
}
export const CbSimplePagination: FC<CbSimplePaginationProps> = ({
  buttonSize = 6,
  buttonStyles,
  containerStyles,
  count,
  currentIndex = 0,
  textStyles,
  onChange
}) => {
  const label = count ? `${currentIndex + 1} of ${count}` : '';
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === count - 1;
  const handlePrevClick = () => {
    onChange && onChange(currentIndex - 1);
  };
  const handleNextClick = () => {
    onChange && onChange(currentIndex + 1);
  };
  return <>
      <Text marginRight={3} {...textStyles} data-sentry-element="Text" data-sentry-source-file="CbSimplePagination.tsx">
        {label}
      </Text>
      <Flex {...containerStyles} data-sentry-element="Flex" data-sentry-source-file="CbSimplePagination.tsx">
        <CbArrow data-testid="prev-button" aria-label="Previous" direction="left" isDisabled={isFirst} marginRight={`${buttonSize}px`} height={buttonSize} width={buttonSize} minWidth={buttonSize} padding={0} onClick={handlePrevClick} size="sm" {...buttonStyles} variant="ghost-on-dark" data-sentry-element="CbArrow" data-sentry-source-file="CbSimplePagination.tsx" />
        <CbArrow data-testid="next-button" aria-label="Next" direction="right" isDisabled={isLast} height={buttonSize} width={buttonSize} minWidth={buttonSize} padding={0} onClick={handleNextClick} size="sm" {...buttonStyles} variant="ghost-on-dark" data-sentry-element="CbArrow" data-sentry-source-file="CbSimplePagination.tsx" />
      </Flex>
    </>;
};